module.exports = __webpack_public_path__ + "img/error@3x.e5242e49.png";